import { render, staticRenderFns } from "./lottery-tnc.vue?vue&type=template&id=6dfc58aa&scoped=true&"
import script from "./lottery-tnc.vue?vue&type=script&setup=true&lang=ts&"
export * from "./lottery-tnc.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./lottery-tnc.vue?vue&type=style&index=0&id=6dfc58aa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc58aa",
  null
  
)

export default component.exports